import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';

const MealOrderingBottomBanner = ({ onClose, isTrainRunning }) => {
  const isMobileDevice = isMobile();

  if (!isMobileDevice) {
    return null;
  }

  const handleOrderMealsClick = () => {
    window.location.href = 'https://www.makemytrip.com/railways/food';
  };

  const containerStyle = {
    position: 'fixed',
    bottom: isTrainRunning ? '85px' : '0',
    left: 0,
    right: 0,
    background: '#ffffff',
    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.15)',
    zIndex: 9998,
    padding: '12px 16px',
    borderTop: '1px solid #e0e0e0'
  };

  const contentWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    paddingRight: '24px'
  };

  const leftSectionStyle = {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    marginRight: '12px'
  };

  const iconStyle = {
    width: '40px',
    height: '40px',
    marginRight: '12px',
    flexShrink: 0
  };

  const textStyle = {
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    color: '#4a4a4a',
    lineHeight: '1.4',
    flex: 1
  };

  const buttonStyle = {
    backgroundImage: 'linear-gradient(96deg, #53b2fe, #065af3)',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 16px',
    fontFamily: 'Lato, sans-serif',
    fontSize: '12px',
    fontWeight: 700,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '-4px',
    right: '-8px',
    background: 'transparent',
    border: 'none',
    fontSize: '20px',
    color: '#999',
    cursor: 'pointer',
    padding: 0,
    width: '20px',
    height: '20px',
    lineHeight: 1
  };

  return (
    <div style={containerStyle}>
      <div style={contentWrapperStyle}>
        <div style={leftSectionStyle}>
          <img
            src="https://go-assets.ibcdn.com/u/MMT/images/1748794706992-mealsBox.webp"
            alt="Meals"
            style={iconStyle}
          />
          <div style={textStyle}>Now enjoy food from favourite restaurants at your seat</div>
        </div>

        <button onClick={handleOrderMealsClick} style={buttonStyle}>
          Order Meals
        </button>

        <button onClick={onClose} aria-label="Close" style={closeButtonStyle}>
          ×
        </button>
      </div>
    </div>
  );
};

MealOrderingBottomBanner.propTypes = {
  onClose: PropTypes.func,
  isTrainRunning: PropTypes.bool
};

export default MealOrderingBottomBanner;
